import internalApi from "../axios/internalApi";
import { message } from "antd";

export const login = async (payload) => {
  try {
    const res = await internalApi.post(
      { server: "api/v1/", path: "auth/login" },
      payload
    );
    return res;
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const logout = async () => {
  try {
    return await internalApi.post({ server: "api/v1/", path: "auth/logout" });
  } catch (error) {
    message.error(error?.data?.message);
  }
};
export const getAccessRefreshToken = async (payload) => {
  try {
    return await internalApi.post(
      {
        server: "api/v1/",
        path: "auth/refresh-token",
      },
      payload
    );
  } catch (e) {
    window.location.href = "/login";
  }
};
